import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';

import { ReactComponent as Logo } from '../../assets/logos/carp-logo.svg';

import './about.styles.scss';

const About = () => {
  return (
    <>
      <div id='about' className='about-section'>
        <div className='above-section'>
          <div className='about-logo'>
            <Logo />
          </div>
          <div className='social-icons'>
            <div className='social-spec'>
              <a href='#facebook'>
                <FaFacebook />
              </a>
              <a href='#instagram'>
                <FaInstagram />
              </a>
              <a href='#youtube'>
                <FaYoutube />
              </a>
            </div>
            <div className='lang'>
              <a href='#ua-lang'>UA</a>/<a href='#en-lang'>ENG</a>
            </div>
          </div>
        </div>
        <div className='about-container row justify-content-md-center'>
          <div className='about-heading-title'>ПРО НАС</div>
          <div className='about-content-section col col-lg-2'>
            <div className='about-title'>Декілька слів про нашу команду</div>
          </div>
          <div className='about-image-section'>
            <p>
              <span>Carpenko</span> - українська команда, що об'єднала
              талановитих дизайнерів та теслярів. <br />
              Ми просто одержимі красивими та практичними речами з дерева.
              Захоплюємося нашими віковими традиціями, а також досліджуємо Схід
              та Захід.
              <br /> Головне для нас - щирість у праці та увага до дрібниць.
              <br /> Ми не бажаємо просто змінити побут,
              <br /> ми хочемо змінити життя.
            </p>
          </div>
          <div className='bottom-line'></div>
        </div>
      </div>
    </>
  );
};

export default About;
